export default __webpack_public_path__ + "assets/images/936aea1ad64770ef63d0cc4602b51409.png";